import { FormField } from 'components/FormField';
import { useState } from 'react';
import { NextButton } from 'components/NextButton';
import { useFlag } from 'services/flags/hooks';
import { Flags } from 'services/flags/constants';
import { useExternalIdAndJobDescription } from 'common/hooks/useExternalIdAndJobDescription';

export const NoATSJobDescriptionStep: React.FC<{
  jobDescription: string;
  externalId?: string;
  onNext: (jobDescription: string, externalId?: string) => void;
}> = ({
  jobDescription: initialJobDescription,
  externalId: initialExternalId,
  onNext
}) => {
  const isExternalIdRequiredFlag = useFlag(Flags.EXTERNAL_ID_IS_MANDATORY);

  const [jobDescription, setJobDescription] = useState(initialJobDescription);
  const [externalId, setExternalId] = useState<string | undefined>(
    initialExternalId
  );

  const { errors, handleFieldChange, handleValidation } =
    useExternalIdAndJobDescription({
      jobDescriptionText: jobDescription,
      externalId: externalId
    });

  const handleNext = () => {
    if (handleValidation()) {
      // Validation casts but does not update local state, so trim before handing it on.
      onNext(jobDescription, externalId?.trim() || undefined);
    }
  };

  return (
    <FormField
      width={700}
      title="Add job description"
      subTitle="Candidate CVs and applications will be ranked against this."
      textFields={[
        {
          label: 'Write or paste the job description',
          maxCharacters: 6000,
          props: {
            multiline: true,
            rows: 14,
            id: 'nonAtsJobDescription',
            name: 'nonAtsJobDescription',
            value: jobDescription,
            error: errors.jobDescription,
            errorText: 'Enter a job description.',
            onChange: (e) => {
              setJobDescription(e.target.value);
              handleFieldChange('jobDescription', e.target.value);
            }
          }
        },
        {
          label: `${
            isExternalIdRequiredFlag ? 'External ID' : 'External ID (optional)'
          }`,
          props: {
            subLabel: 'Identifies your campaign in Popp’s API.',
            id: 'externalId',
            name: 'externalId',
            value: externalId,
            error: errors.externalId,
            errorText: 'Enter an external ID.',
            onChange: (e) => {
              setExternalId(e.target.value);
              handleFieldChange('externalId', e.target.value);
            }
          }
        }
      ]}
      customComponents={[
        <NextButton handleNext={handleNext} nextText="Next" />
      ]}
    />
  );
};
